import { styled } from '@mui/system';
import { Typography } from '@components/Typography';
import { ArrowDownIcon } from 'assets/images/icons';
import { formatNumber, formatPercentNumber } from '@helpers/formatNumbers';

const ArrowDown = styled(ArrowDownIcon, {
    shouldForwardProp: prop => prop !== 'isUp' && prop !== 'isGreen' && prop !== 'isRed',
})(({ isUp, isGreen, isRed }) => ({
    width: 4,
    marginRight: 5,
    transform: 'translateY(-1px)',
    ...(isUp && {
        transform: 'translateY(-1px) rotate(180deg)',
    }),
    ...(isGreen && {
        '& path': {
            fill: 'var(--success-main)',
            fillOpacity: 1,
        },
    }),
    ...(isRed && {
        '& path': {
            fill: 'var(--error-main)',
            fillOpacity: 1,
        },
    }),
}));

const Percentage = ({ value, withSign = true }) => {
    const isPositive = value > 0;
    const isZero = value === 0;
    return (
        <Typography
            variant="caption"
            color="textSecondary"
            sx={{
                color: isPositive ? 'var(--success-main)' : isZero ? 'var(--text-secondary)' : 'var(--error-main)',
                display: 'initial',
                alignItems: 'center',
            }}
        >
            {!isZero ? (
                isPositive ? (
                    <ArrowDown isUp={!!isPositive} isGreen={isPositive} isRed={!isPositive} />
                ) : (
                    <ArrowDown isGreen={isPositive} isRed={!isPositive} />
                )
            ) : null}
            {withSign ? formatPercentNumber(value) : formatNumber(value)}
        </Typography>
    );
};

export default Percentage;
